package org.gstechnovos.jexonplastech.sections.contact.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ContactInfoContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.white)
            // Negative top margin so the cards overlap the blue header slightly for a premium look
            .margin(top = 60.px, bottom = 60.px)
            .padding(topBottom  = 80.px)
            .zIndex(1)
    }
}

val ContactCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .height(100.percent)
            .padding(32.px)
            .backgroundColor(palette.custom.white)
            .borderRadius(16.px)
            .boxShadow(0.px, 10.px, 30.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.08f))
            .transition(
                Transition.of("transform", 0.3.s),
                Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        Modifier
            .translateY((-8).px)
            .boxShadow(0.px, 20.px, 40.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.15f))
    }
}